<template>
    <div class="main">
        <van-sticky>
            <van-tabs v-model="active" color="#FEB013" @click="getDataList">
                <van-tab title="待接单"> </van-tab>
                <van-tab title="已接单"> </van-tab>
                <van-tab title="运送中"> </van-tab>
                <van-tab title="已签收"> </van-tab>
            </van-tabs>
        </van-sticky>
        <div v-if="list.length">
            <div class="div_card" v-for="(item, key) in list" :key="key">
                <div class="div_flex" style="border-bottom: 1px #D2D2D2 solid;">
                    <div>{{ item.Status }}</div>
                    <div v-if="item.DriverId" style="font-size: 14px;">送货司机：{{ item.Driver }} {{ item.DriverPhone }}
                    </div>
                </div>
                <div class="div_flex">
                    <div style="display: flex;">
                        <a class="div_icon" style="background-color: #333333;">发</a>
                        <div class="div_address">{{ item.DeliveryAddress }}</div>
                    </div>
                    <div class="div_flex">
                        <a class="div_icon" style="background-color: #FEB013;">收</a>
                        <div class="div_address">{{ item.ShipAddress }}</div>
                    </div>
                </div>
                <div style="padding: 6px 0;">送货时间：{{ item.DeliveryTime }}</div>
                <div style="padding: 6px 0;">
                    <a>货物名称：{{ item.ItemName }}</a>
                    <a style="padding-left: 18px;">数量：{{ item.ItemNum }}</a>
                    <a style="padding-left: 18px;">单位：{{ item.ItemUnit }}</a>
                </div>
                <div class="div_flex" style="border-top: 1px #D2D2D2 solid;">
                    <div>收货人：{{ item.Receiver }}</div>
                    <van-button size="small" round color="#FEB013" @click="goToDetail(item, 'driver')">订单详情</van-button>
                </div>
            </div>
        </div>
        <div v-else>
            <van-empty description="暂无数据" />
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            WXInfo: {},
            list: [],
            active: 0
        }
    },
    async mounted() {
        // const test = { "errno": 0, "data": { "errcode": 0, "errmsg": "ok", "userid": "2012224", "name": "蔡志恒", "department": [2267], "position": "软件开发工程师", "mobile": "15812615614", "gender": "1", "email": "wuchangyue@jianlianmed.com", "avatar": "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0", "status": 1, "isleader": 0, "extattr": { "attrs": [{ "name": "英文名", "value": "", "type": 0, "text": { "value": "" } }, { "name": "工号", "value": "2017551", "type": 0, "text": { "value": "2017551" } }, { "name": "身份证", "value": "", "type": 0, "text": { "value": "" } }] }, "english_name": "", "telephone": "020-88985632", "enable": 1, "hide_mobile": 0, "order": [0], "external_profile": { "external_attr": [], "external_corp_name": "" }, "main_department": 2267, "qr_code": "https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c", "alias": "", "is_leader_in_dept": [0], "address": "", "thumb_avatar": "http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100", "direct_leader": [], "openid": "o_Td1s7gCLuLiZITNxC3ApjOLC7U", "access_token": "hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w" } }
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data

        await this.getDataList(this.active, '待接单')
    },
    methods: {
        goToDetail(item, role) {
            this.$router.push({
                path: '/transport/detail',
                query: {
                    id: item._id,
                    role: role
                }
            })
        },
        async getDataList(key, title) {
            const result = await this.$request({
                url: '/api/GeneralMethod/getFunctionList',
                method: 'GET',
                params: {
                    DriverId: key ? this.WXInfo.name === '王海苑' ? '' : this.WXInfo.userid : '',
                    Status: title,
                    Model: 'transport'
                }
            })
            if (result.data) {
                this.list = result.data
            }
        }
    }
}
</script>

<style>
#app {
    height: auto;
    min-height: 100vh;
}
</style>
<style lang="less" scoped>
.main {
    overflow: hidden;
}

.div_card {
    border-radius: 8px;
    padding: 6px 12px;
    margin: 12px;
    background-color: #fff;
}

.div_icon {
    font-size: 14px;
    font-weight: normal;
    color: #FFFFFF;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
}

.div_flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
}

.div_card_diver {
    background-color: #3F97FC;
    color: #fff;
    border-radius: 12px;
    margin: 12px;
    padding: 12px;
    line-height: 1.5;
}
.div_address {
    white-space: pre-wrap;
    word-break: keep-all;
    text-align: center;
    font-size: 13px;
}
</style>
  